import { ComponentsVariants, isVariantOf } from '@/components.variants';

export const isPowerApps = isVariantOf(ComponentsVariants.POWER_APPS, true);

export default (ravVal: any, page: any, pageModels: any) => {
  return {
    variant: ComponentsVariants.POWER_APPS,
    srcUrl: ravVal?.powerapps,
    title: '',
    showResizeButton: false,
  };
};
